import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import addPart from '../parts/addPart'
import { platformSpeed } from '../state/globals'
import addVoid from '../parts/addVoid'

export default () => {
  k.setGravity(1000)
  k.add([k.sprite('background'), k.fixed()])

  const { partDisplay } = addUI(3)

  const robot = addRobot(true, partDisplay)
  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  addPart(partDisplay, 130, 0)
  addPart(partDisplay, 20, 100)
  addPart(partDisplay, 85, 100)
  addPart(partDisplay, 150, 100)

  addVoid(350)

  k.add([
    k.sprite('grass'),
    k.pos(-20, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  const platform = k.add([
    k.sprite('platform'),
    k.pos(220, 110),
    k.body({ isStatic: true }),
    k.area()
  ])

  let direction = platformSpeed
  platform.onUpdate(() => {
    if (platform.worldPos().y <= 20) direction = platformSpeed
    else if (platform.worldPos().y >= 120) direction = -platformSpeed

    platform.move(k.vec2(0, direction))
  })

  k.add([
    k.sprite('grass'),
    k.pos(-20, 120),
    k.body({ isStatic: true }),
    k.area()
  ])

  const lowergrassFinal = k.add([
    k.sprite('grass'),
    k.pos(320, 120),
    k.body({ isStatic: true }),
    k.area()
  ])

  const door = lowergrassFinal.add([
    k.sprite('door'),
    k.pos(200, 0),
    k.area(),
    k.anchor('bot'),
    k.z(-1),
    'door'
  ])

  let atDoor = false
  let doorOpen = false

  robot.onCollide('door', () => {
    atDoor = true
    tooltipE.hidden = false
  })
  robot.onCollideEnd('door', () => {
    atDoor = false
    tooltipE.hidden = true
  })
  robot.onKeyPress('e', () => {
    if (atDoor && !doorOpen) {
      doorOpen = true
      door.play('open')
    } else if (atDoor && doorOpen) {
      k.go('four')
    }
  })
}
